import { VueConstructor } from "vue";

type PropsCarrier = { options: { props: Record<string, unknown> } };


export function disableTabsSwipe(tabsItems: VueConstructor): void {
  const ctor = (tabsItems as unknown) as PropsCarrier;
  ctor.options.props = {
    ...ctor.options.props,
    touchless: { type: Boolean, default: true },
  };
}
